import { apiRequest } from '@/utils/api-request';
import type { OrgSchedule } from '@/types/schedules';

export async function listOrgSchedules(orgId: string): Promise<OrgSchedule[]> {
  const response = await apiRequest<OrgSchedule[]>({
    url: `/api/v1/orgs/${orgId}/schedules`,
    method: 'GET',
    target: 'workflow',
  });
  if (response.detail) throw new Error(response.detail);
  return response.data || [];
}
